import environment from '@/helpers/Environment'
import currencyFormatter from 'currency-formatter'

/**
 * Format a currency, using the current portal default currency code if
 * none is given.
 **/
export function formatCurrency(amount: number, code: string = environment.portal.default_currency_code): string {
  return currencyFormatter.format(amount, { code })
}

export function currencySymbol(code: string = environment.portal.default_currency_code): string {
  return currencyFormatter.findCurrency(code).symbol
}
